<template>
  <el-dialog
    title="退款详情"
    :visible="visible"
    :close-on-click-modal="false"
    width="500px"
    top="5vh"
    @close="onDialogClose"
    append-to-body
  >
    <div class="detail-dialog-content">
      <el-form size="small" label-width="90px">
        <el-form-item label="订单编号: ">
          <span>{{ refundDetail.outTradeNo }}</span>
          <el-button
            type="text"
            size="small"
            style="margin-left: 10px;"
            @click="viewOrder"
            v-if="refundDetail.outTradeNo"
          >查看订单</el-button>
        </el-form-item>
        <el-form-item label="退款单号: ">
          <span>{{ refundDetail.refundNum }}</span>
        </el-form-item>
        <el-form-item label="支付金额: ">
          <span>{{ (refundDetail.totalPayFee / 100) || '-' }}元</span>
        </el-form-item>
        <el-form-item label="退款方式: ">
          <span>{{ refundDetail.refundFunText || '-' }}</span>
        </el-form-item>
        <el-form-item label="退款金额: ">
          <span>{{ (refundDetail.refundAmount / 100) || '-' }}元</span>
        </el-form-item>
        <el-form-item label="退款原因: ">
          <el-input
            :value="refundDetail.refundReason"
            disabled
            readonly
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
          />
        </el-form-item>
        <el-form-item label="申请人: ">
          <span>{{ refundDetail.refundApplyUser }}</span>
        </el-form-item>
        <el-form-item label="申请时间: ">
          <span>{{ refundDetail.createTime }}</span>
        </el-form-item>
        <el-form-item label="退款状态: ">
          <span>{{ refundDetail.refundStatusText }}</span>
        </el-form-item>
        <el-form-item label="处理人: ">
          <span>{{ refundDetail.refundHandleUser }}</span>
        </el-form-item>
        <el-form-item label="处理时间: ">
          <span>{{ refundDetail.handleTime }}</span>
        </el-form-item>
        <el-form-item label="处理意见: ">
          <el-input
            :value="refundDetail.mark"
            disabled
            readonly
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
          />
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TerminalDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    refundDetail: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onDialogClose() {
      this.$emit('update:visible', false);
    },
    viewOrder() {
      this.onDialogClose()
      this.$router.push({
        path: '/memberNew/terminalOrder/index',
        query: {
          outTradeNo: this.refundDetail.outTradeNo
        }
      })
    }
  }
};
</script>
